import React, { lazy, Suspense, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { LOGIN, MAINTENANCE, PAGE_404, ROOT } from "../../constants/routes";
import LoadingPage from "../../components/Common/LoadingPage";

// Lazy load components
const Page404 = lazy(() => import("../ErrorPages/Page404"));
const ClientLayoutNew = lazy(() => import("./ClientLayoutNew"));
const PublicLayout = lazy(() => import("./PublicLayout"));
const Login = lazy(() => import("../Login/Login"));
const Maintenance = lazy(() => import("../ErrorPages/Maintenance"));

const isServerDown = process.env.REACT_APP_IS_MAINTENANCE === "true";

const Layout = () => {
    useEffect(() => {
        const handleUnhandledRejection = event => {
            console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`);
        };

        window.addEventListener("unhandledrejection", handleUnhandledRejection);

        return () => {
            window.removeEventListener(
                "unhandledrejection",
                handleUnhandledRejection
            );
        };
    }, []);

    if (isServerDown) {
        return (
            <Suspense fallback={<LoadingPage />}>
                <Switch>
                    <Route path="" component={Maintenance} />
                </Switch>
            </Suspense>
        );
    }

    return (
        <Suspense fallback={<LoadingPage />}>
            <Switch>
                <Route path={LOGIN} exact component={Login} />
                <Route path={PAGE_404} exact component={Page404} />
                <Route
                    path={ROOT}
                    render={props =>
                        props.location.pathname.includes("client") ? (
                            <ClientLayoutNew {...props} />
                        ) : (
                            <PublicLayout {...props} />
                        )
                    }
                />
                <Route
                    path="/"
                    exact
                    component={() => <Redirect to={ROOT} />}
                />
                <Route path="" exact component={() => <Redirect to={ROOT} />} />
            </Switch>
        </Suspense>
    );
};

Layout.propTypes = {
    location: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    pathname: state.router.location.pathname
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
